import { createReducer, Action, on } from '@ngrx/store';
import { State, initialState } from './state';
import * as actions from './actions';

const reducer = createReducer(
  initialState,
  on(actions.load, (state => {
    return {
      ...state,
      loading: true
    };
  })),
  on(actions.loadSuccess, ((state, { organizations })  => {
    return {
      ...state,
      loading: false,
      data: organizations
    };
  })),
  on(actions.loadFail, ((state, { error })  => {
    return {
      ...state,
      loading: false,
      error
    };
  })),
);

export function organizationsReducer(state: State, action: Action) {
  return reducer(state, action);
}
